<template>
  <div class="page-container">
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202405/04/01.png" />
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202405/04/02.jpg" />
      <div class="rule" @click="$refs.rulesRef.open()"></div>
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202405/04/03.jpg" />
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202405/04/04.jpg" />
      <div class="achievement" v-html="performanceText" v-if="!preview"></div>
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202405/04/05.jpg" />
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202405/04/06.jpg" />
      <div class="detail-btn" @click="goDetail(0)"></div>
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202405/04/07.jpg" />
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202405/04/08.jpg" />
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202405/04/09.jpg" />
      <div class="detail-btn" @click="goDetail(1)"></div>
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202405/04/10.jpg" />
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202405/04/11.jpg" />
      <div class="detail-btn" @click="goDetail(2)"></div>
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202405/04/12.jpg" />
      <div class="go-order" @click="goOrderDetail('12602')"></div>
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202405/04/13.jpg" />
      <div class="go-order" @click="goOrderDetail('12601')"></div>
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202405/04/14.jpg" />
      <div class="go-order" @click="goOrderDetail('250346')"></div>
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202405/04/15.jpg" />
      <div class="go-order" @click="goOrderDetail('22014')"></div>
    </div>

    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202405/04/16.png" />
    </div>

    <!-- 规则 -->
    <activityRules ref="rulesRef" :ruleText="ruleText"></activityRules>
  </div>
</template>

<script>
import config from '@/api/common'; //公共变量
import { common } from '@/api/mixins';
import activityRules from './components/rulePopup';

export default {
  components: {
    activityRules
  },
  mixins: [common],
  data() {
    return {
      preview: false,
      userInfo: JSON.parse(localStorage.getItem('jzy_user')),
      performanceText: '',
      ruleText:
        '<p style=\"text-align:center;\"><span style=\"font-size: 22px;\">规则详情</span><br/></p><div><h2 style="margin-top: 10px;">一、活动时间：</h2><p>2024年5月1日——2024年5月31日</p><p><br/></p><h2>二、活动对象：</h2><p>OK保已签约代理人</p><p><br/></p><h2>三、活动参与：</h2><p>出单OK保所有团险产品且保费满足要求</p><p>活动产品清单</p><p><img src=\"https://file-test.lazhuyun.cn/upload/image/2024/04/07/1712487645821081648.png\" style=\"max-width:100%;\" contenteditable=\"false\"/></p><p><img src=\"\"/></p><h2>四、59988元阶梯现金奖</h2><h3>（一）活动内容</h3><p>活动期间内出单团险产品，累计保费达标可获得对应奖励</p><p>满1万元，奖励218元</p><p>满3万元，奖励888元</p><p>满10万元，奖励2888元</p><p>满50万元，奖励20088元</p><p>满100万元，奖励59988元</p><h3>（二）注意事项</h3><p><span>\n            1、<span>&nbsp;</span></span>\n    活动奖励取实现的最高档为主，不可重复叠加获得</p><p><span>\n            2、<span>&nbsp;</span></span>\n    奖励仅针对活动期间活动产品新单保费，保全不参与</p><p><br/></p><h2>五、首单有奖</h2><h3>（一）活动内容</h3><p>活动期间内开单保费首次大于或等于3000元奖励128元，仅限1次</p><h3>（二）注意事项</h3><p>奖励仅针对活动期间活动产品新单保费，保全不参与</p><p><br/></p><h2>六、单单有奖</h2><h3>（一）活动内容</h3><p>活动期间内出单任意团险产品，且每单保费大于或等于5000元，按照单数计算，每出一单，奖励88元现金，多出多得。</p><h3>（二）注意事项</h3><p><span>\n            1、<span>&nbsp;</span></span>\n    奖励仅针对活动期间活动产品新单保费，保全不参与</p><p>2、严禁恶意拆单，若发现多笔订单均为同一企业、同一出单人、同一产品，则视为同一个订单，仅发放一次奖励。</p><p><br/></p><h2>七、活动规则</h2><p><span>\n            1、<span>&nbsp;</span></span>\n    3项团险开单活动奖励可叠加。</p><p><span>\n            2、<span>&nbsp;</span></span>\n    如遇退保，OK保将扣回此单所有推广费及所有活动奖励。如发现同一代理人活动期间退保率超过2%，OK保有权追回所有奖励。</p><p><span>\n            3、<span>&nbsp;</span></span>\n    活动订单仅计算活动期间所出新单，保全不参与。</p><p>4、参加活动要求个人历史退保率&lt;2%，达标与否，将以活动开始前定版数据&nbsp;(即2024.4月7日零点系统数据)&nbsp;为准。</p><p>5、代理人若在奖励发放前离职或停职，则奖励不予结算。</p><p><br/></p><h2>八、活动奖励发放</h2><p>1、奖励将会在活动结束后的次月20日之后进行发放。产生退保的订单奖励不予结算。领取途径：进入APP我的页面——点击可提现——提现到银行卡。</p><p>2、退保的情况下，业绩数据同步会有延迟，以活动结束后的最终核算业绩（扣除退保件等）为主，来进行活动奖励发放。</p><p><br/></p><h2>九、活动参与资格、获奖资格的取消</h2><p>本活动严禁一切不正当手段和舞弊行为，用户若有下列任何一种行为或情况的，OK保有权单方面取消异常用户的活动参与资格、所有奖励获奖资格。</p><p>1、不符合活动参与资格的，提供虚假个人信息和邀请信息参与活动，进行虚假注册、签约和交易的。</p><p>2、恶意破坏活动，以任何机器人软件、蜘蛛软件、爬虫软件、刷奖软件或其它任何自动方式、不正当手段等参与本活动的。</p><p>3、违反诚实信用、公序良俗、公平、公正等原则行为，违反相关法规、本活动规则行为。</p><p><br/></p><h2>十、免责条款</h2><p>互联网运行存在诸多不确定性因素，如因不可抗力、网络、通讯线路故障、计算机大规模瘫痪及活动中存在大面积作弊行为等原因致使本活动出现异常情况或难以继续开展的，OK保有权采取包括但不限于通过各种方式消除异常情况或调整、暂停、取消本活动等合理措施保障OK保及用户的合法权益，您表示理解，由此给您造成的损失，您同意不追究OK保的责任。</p><p>以上奖励条件以系统记录为准，若出现刷量或恶意投诉，OK保将保留追究法律责任的权利。本活动最终解释权归梧桐树保险经纪有限公司所有。</p></div><div></div><div><div></div></div>',
      activityIds: [],
      activityList: []
    };
  },

  created() {
    this.preview = this.$route.query.preview ? true : false;
    if (this.$route.query.preview) return;
    // 地址栏配置id
    let ids = this.$route.query.ids;
    if (ids) {
      this.activityIds = ids.split(',');
    } else if (config.env == '0' || config.env == '2') {
      // 本地、测试
      this.activityIds = ['1784516715334156290', '1784516748733399042', '1784516761848987650'];
    } else {
      // 正式
      this.activityIds = ['1784853377868754945', '1784853613072740353', '1784854099091169282'];
    }
    this.getList();
    this.getPerformance();
  },

  methods: {
    // 获取活动详情
    getList() {
      this.$http({
        type: 'GET',
        url: '/app/merchantActivity/detailList',
        data: {
          idList: this.activityIds.join(',')
        }
      }).then(res => {
        this.activityList = res.data;
      });
    },

    // 参与详情
    goDetail(index) {
      if (this.preview) return;
      this.$router.push({
        path: '/apps/partakeList',
        query: {
          id: this.activityIds[index],
          type: this.activityList[index].type,
          calFactor: this.activityList[index].calFactor,
          productType: this.activityList[index].productType,
          mode: this.activityList[index].mode,
          status: this.activityList[index].status,
          conditionalIndicator: this.activityList[index].conditionalIndicator,
          activityType: 'group'
        }
      });
    },

    // 去出单
    goOrderDetail(code) {
      if (this.preview) return;
      let url = '';
      if (config.env == '0' || config.env == '2') {
        url = `https://fqjdstore.wts9999.net/m/product/app/detail/groupInsurance?userId=${this.userInfo.userId}&productCode=${code}`;
      } else {
        url = `https://jdstore.fxyf99.com/m/product/app/detail/groupInsurance?userId=${this.userInfo.userId}&productCode=${code}`;
      }
      window.location.href = url;
    },

    // 获取活动一开单业绩
    getPerformance() {
      this.$http({
        type: 'GET',
        url: '/api/okbAct/actLotteryPolicyLog/queryActPolicyAmount',
        data: {
          activityId: this.activityIds[0]
        }
      }).then(res => {        
        if (res.data.amount >= 0 && res.data.amount < 10000) {
          this.performanceText = `活动业绩为<span style="color:#ffe6a5;">${res.data.amount}元</span>，还差<span style="color:#ffe6a5;">${10000 - Number(res.data.amount)}元</span>可获得<span style="color:#ffe6a5;">218元</span>`;
        } else if (res.data.amount >= 10000 && res.data.amount < 30000) {
          this.performanceText = `活动业绩为<span style="color:#ffe6a5;">${res.data.amount}元</span>，还差<span style="color:#ffe6a5;">${30000 - Number(res.data.amount)}元</span>可获得<span style="color:#ffe6a5;">888元</span>`;
        } else if (res.data.amount >= 30000 && res.data.amount < 100000) {
          this.performanceText = `活动业绩为<span style="color:#ffe6a5;">${res.data.amount}元</span>，还差<span style="color:#ffe6a5;">${100000 - Number(res.data.amount)}元</span>可获得<span style="color:#ffe6a5;">2888元</span>`;
        } else if (res.data.amount >= 100000 && res.data.amount < 500000) {
          this.performanceText = `活动业绩为<span style="color:#ffe6a5;">${res.data.amount}元</span>，还差<span style="color:#ffe6a5;">${500000 - Number(res.data.amount)}元</span>可获得<span style="color:#ffe6a5;">20088元</span>`;
        } else if (res.data.amount > 1000000) {
          this.performanceText = `活动业绩为<span style="color:#ffe6a5;">${res.data.amount}元</span>，已获得<span style="color:ffe6a5e;">59988元</span>奖励`;
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  .container {
    position: relative;
    .img {
      width: 750px;
      display: block;
    }
    .rule {
      width: 72px;
      height: 70px;
      position: absolute;
      top: 0px;
      right: 2px;
    }
    .detail-btn {
      width: 300px;
      height: 90px;
      position: absolute;
      top: 0;
      left: 50%;
      margin-left: -150px;
      border-radius: 45px;
    }
    .go-order {
      position: absolute;
      width: 150px;
      height: 50px;
      border-radius: 25px;
      right: 90px;
      bottom: 0;
    }
    .achievement {
      height: 58px;
      background: #f76433;
      position: absolute;
      top: 58px;
      left: 60px;
      display: flex;
      align-items: center;
      padding: 0 20px;
      color: #fff;
      font-size: 26px;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
      letter-spacing: 0.3px;
    }
  }
}
</style>
